// Todo texto visível do site vem daqui. Variáveis entre chaves: {nome}.
export const en = {
  siteName: "Aulra Interpreter",
  loading: "Loading…",
  genericError: "Something went wrong. Please try again.",
  networkError: "Could not reach the server. Check your connection and try again.",

  // Textos fixos do spec
  suspended: "Your account is suspended. Contact support.",
  pending: "Your account is awaiting approval. We'll email you when it's ready.",
  historyMonth: "This month: broadcasts {count} · language-hours {hours}.",
  billingSoon: "coming soon",

  // Home pública (SITE-HOME). Sem preços nem regras do teste: D6 em aberto.
  homeSignIn: "Sign in",
  siteBrand: "Aulra",
  siteTitle: "Aulra · Live translation for live events",
  siteSkip: "Skip to content",
  siteNavLabel: "Main",
  siteMenu: "Sections",
  siteNavHow: "How it works",
  siteNavHear: "Example",
  siteNavPricing: "Pricing",
  siteSignUp: "Create an account",
  siteHeroTitle: "Everyone in the room, in their own language.",
  siteHeroLead: "Live translation from Portuguese into English and Spanish, from the speaker's microphone to each person's earbuds. Nothing to install. Nothing stored.",
  siteHeroHow: "See how it works",
  siteHeroNote: "For talks, workshops, conferences, classes: any event with one person speaking.",
  siteProblemTitle: "Some of your people are listening from the outside.",
  siteProblemLead: "The guests who flew in for the conference. The new colleague who thinks in English. The visitor who speaks Spanish and doesn't come back. They're in the room, but the message isn't reaching them.",
  siteProblem1Title: "The guests from abroad.",
  siteProblem1Body: "Invited, seated up front, following along on the slides.",
  siteProblem2Title: "The kids who grew up abroad.",
  siteProblem2Body: "Fluent at home, lost in Portuguese.",
  siteProblem3Title: "The first-time visitor.",
  siteProblem3Body: "Welcomed at the door, lost by the second sentence.",
  siteTurnTitle: "Then someone leans over and whispers every sentence in their language.",
  siteTurnLead: "That's what Aulra does, for everyone at once. The speaker talks in Portuguese. A sentence later, each listener hears it in English or Spanish, on their own phone, at their own volume.",
  siteTurnNote: "Each person hears it alone, without disturbing anyone.",
  siteHowTitle: "Three steps before you go live.",
  siteHowLead: "One person can set it up alone.",
  siteStep1Title: "Connect a microphone",
  siteStep1Body: "Use your laptop or phone's own mic, or connect a Bluetooth or USB one. Then sign in and open the Aulra console in your browser.",
  siteStep2Title: "Show the code",
  siteStep2Body: "Project the QR code on the screen or print it for the seats. People scan it with their phone camera. Nothing to install.",
  siteStep3Title: "They listen",
  siteStep3Body: "Each person picks English or Español and listens with their own earbuds.",
  siteHearTitle: "What listeners hear.",
  siteHearLead: "One sentence in Portuguese, and the same sentence as listeners hear it in English and in Spanish.",
  siteSampleLabel: "Example sentence",
  siteSamplePtName: "Português · original",
  siteSamplePtText: "“Ninguém aqui deveria ouvir do lado de fora.”",
  siteSampleEnName: "English",
  siteSampleEnText: "“No one here should have to listen from the outside.”",
  siteSampleEsName: "Español",
  siteSampleEsText: "“Nadie aquí debería escuchar desde afuera.”",
  siteFact1Title: "Sentence by sentence.",
  siteFact1Body: "The translation comes right after each sentence the speaker finishes.",
  siteFact2Title: "Nothing to install.",
  siteFact2Body: "Listeners open a web page from the QR code. No app, no account.",
  siteFact3Title: "Their own earbuds.",
  siteFact3Body: "Each person listens on their own phone, at their own volume.",
  sitePrivacyTitle: "What is said in the event stays in the event.",
  sitePrivacyBody: "Aulra translates and forgets. We don't keep audio or transcripts of your events.",
  sitePricingTitle: "Pricing is coming soon.",
  sitePricingLead: "We're finishing our plans. You can create an account now: we review each new organization and email you when it's ready.",
  siteFinalTitle: "At your next event, no one listens from the outside.",
  siteFooterTag: "Live translation for live events.",
  siteFooterNavLabel: "Footer",
  siteFooterLegalSoon: "Privacy policy, terms and contact: coming soon.",

  // Campos comuns
  emailLabel: "Email",
  emailPlaceholder: "you@example.com",
  passwordLabel: "Password",
  passwordPlaceholder: "Your password",
  orgNameLabel: "Organization name",
  orgNamePlaceholder: "Riverside Center",
  codeLabel: "6-digit code",
  codePlaceholder: "123456",

  // Cadastro
  signupTitle: "Create your account",
  signupSubmit: "Create account",
  signupHaveAccount: "Already have an account?",
  signupSignInLink: "Sign in",
  newPasswordLabel: "Choose a password",
  newPasswordPlaceholder: "At least 12 characters",
  ruleLength: "At least 12 characters",
  ruleUpper: "An uppercase letter",
  ruleLower: "A lowercase letter",
  ruleDigit: "A number",
  ruleSymbol: "A special character",
  signupOrgRequired: "Enter your organization name.",
  signupExists: "An account with this email may already exist. Try signing in.",
  signupPrivacy: "Aulra translates and forgets: we don't keep audio or text from your events.",

  // Confirmação de e-mail (estado de signup.html e login.html)
  checkEmailTitle: "Check your email",
  checkEmailBody: "We sent a confirmation link to {email}. Open it to confirm your address, then sign in.",
  checkEmailBodyNoAddress: "We sent you a confirmation link. Open it to confirm your address, then sign in.",
  checkEmailSignIn: "Go to sign in",
  checkEmailResend: "Resend email",
  checkEmailResendIn: "Resend in {seconds} s",
  checkEmailResent: "We sent the email again. Check your inbox and spam folder.",
  checkEmailResendFailed: "Could not resend the email. Wait a minute and try again.",
  checkEmailChange: "Use a different email",

  // Login
  loginTitle: "Sign in",
  loginSubmit: "Sign in",
  loginNoAccount: "New here?",
  loginSignUpLink: "Create an account",
  loginForgot: "Lost your authenticator? Use a recovery code",
  loginInvalid: "Incorrect email or password.",
  loginEmailNotConfirmed: "Confirm your email before signing in. Check your inbox for the link.",
  challengeTitle: "Enter your authenticator code",
  challengeHelp: "Open your authenticator app and type the 6-digit code for Aulra Interpreter.",
  challengeSubmit: "Verify",
  challengeInvalid: "That code is not valid. Check the code and try again.",
  challengeCancel: "Use a different account",
  challengeRecovery: "Lost your authenticator? Use a recovery code",

  // Cadastro do autenticador
  mfaTitle: "Set up your authenticator",
  mfaWhy: "Your account controls what your organization broadcasts. The code on your phone protects it.",
  mfaHelp: "Scan this QR code with an authenticator app (Google Authenticator, 1Password, Authy), then enter the 6-digit code it shows.",
  mfaQrAlt: "QR code to add Aulra Interpreter to your authenticator app",
  mfaSecretLabel: "Can't scan? Enter this key manually:",
  mfaSubmit: "Confirm and continue",
  mfaInvalid: "That code is not valid. Check the code and try again.",
  authTooMany: "Too many attempts. Wait a few minutes and try again.",
  // Turnstile (CAPTCHA) do cadastro, login, reenvio e troca de senha.
  captchaLabel: "Security check",
  captchaPending: "Wait for the security check to finish, then try again.",
  captchaFailed: "The security check didn't pass. Try again.",
  mfaSignOut: "Sign out",

  // Códigos de recuperação
  codesTitle: "Save your recovery codes",
  codesHelp: "If you lose your authenticator, each of these codes can be used once to get back into your account. Store them somewhere safe. They will not be shown again.",
  codesCopy: "Copy",
  codesCopied: "Copied",
  codesDownload: "Download",
  codesFileName: "aulra-recovery-codes.txt",
  codesFileHeader: "Aulra Interpreter recovery codes. Each code can be used once.",
  codesSavedCheckbox: "I saved my recovery codes",
  codesContinue: "Continue",
  codesCopyFailed: "Could not copy. Select the codes and copy them manually.",
  codesGenerateFailed: "Could not generate your recovery codes. Please try again.",
  codesRetry: "Try again",

  // Recuperação
  recoverTitle: "Recover your account",
  recoverHelp: "Sign in with your email and password, then enter one of your recovery codes. You will then set up a new authenticator.",
  recoverSubmit: "Continue",
  recoverCodeTitle: "Enter a recovery code",
  recoverCodeLabel: "Recovery code",
  recoverCodePlaceholder: "ABCDE-FGHJK",
  recoverCodeSubmit: "Use recovery code",
  recoverInvalid: "That recovery code is not valid or was already used.",
  recoverTooMany: "Too many attempts. Wait an hour and try again.",
  recoverBackToSignIn: "Back to sign in",

  // Área do operador (app.html)
  appSignOut: "Sign out",
  appNavLabel: "Sections",
  modeNavLabel: "Mode",
  modeController: "My organization",
  modeAdmin: "Platform admin",
  noOrganization: "This account has no organization. Contact support.",
  noOrganizationAdmin: "This admin account has no organization to broadcast from. Use Platform admin above.",
  navHome: "Home",
  navBroadcast: "Broadcast",
  navHistory: "History",
  navOrganization: "Organization",
  navSecurity: "Security",
  navBilling: "Plan",
  // ORG-PLANO bloqueado (cobrança em desenvolvimento; sem valores até a D6)
  planTitle: "Plan & billing",
  planSoonTitle: "Subscriptions open soon.",
  planSoonBody: "Nothing is charged right now. Your account and broadcasts work as usual.",
  planPriceLine: "US$ {base}/month + US$ {perHour} per language-hour.",
  planStateExempt: "Billing doesn't apply to this organization.",
  planStateCard: "Validate a card to start the free trial. Nothing is charged.",
  planStateTrial: "Free trial: {minutes} language-hour minutes left. You pay nothing during the trial.",
  planStateTrialEnded: "The free trial has ended. Subscribe to keep broadcasting.",
  planStateSubscribe: "No active subscription. New broadcasts are paused until you subscribe.",
  planStateActive: "Subscription active. Next charge on {date}.",
  planStateCanceling: "Active until {date}. After that, new broadcasts are paused.",
  planStatePastDue: "Payment is pending. New broadcasts are paused until it's paid.",
  planCard: "Card •••• {last4}",
  planSubscribe: "Subscribe",
  planUpdatePayment: "Update payment",
  planReactivate: "Reactivate",
  planAddCard: "Add a card",
  planManage: "Manage payment and invoices",
  planUsageTitle: "This billing period",
  planUsagePeriod: "{start} to {end}",
  planUsageLabel: "Usage · {hours} language-hours",
  planBaseLabel: "Subscription",
  planEstimateLabel: "Estimated invoice",
  planAmount: "US$ {amount}",
  planEstimateNote: "Final amount when the period closes.",
  planUsageEmpty: "No translated hours in this period yet.",
  planUsageNone: "Usage appears here once you subscribe.",
  planDetailTitle: "Detail by broadcast",
  planColDate: "Broadcast",
  planColLanguages: "Languages",
  planColHours: "Language-hours",
  planColAmount: "Amount",
  planHoursNote: "Language-hours = broadcast length × audience languages. The number of listeners doesn't change it.",
  planLimitTitle: "Monthly spending limit",
  planLimitNone: "No limit set.",
  planLimitUsed: "US$ {used} of US$ {limit} ({percent}%)",
  planLimitHelp: "We warn you at 80% and 100%. At 100%, the next broadcast needs a confirmation. A broadcast that's already live is never cut.",
  planLimitNoSub: "Available with an active subscription.",
  planLimitSet: "Set limit",
  planLimitChange: "Change limit",
  planLimitRemove: "Remove limit",
  planLimitLabel: "Amount per month, whole invoice (US$)",
  planLimitPreview: "About {hours} language-hours fit in a month with this limit.",
  planLimitInvalid: "Enter an amount between US$ {min} and US$ {max}.",
  planLimitOperators: "Allow operators to confirm going live after the limit",
  planLimitSave: "Save limit",
  planLimitSaved: "Limit saved.",
  planLimitRemoved: "Limit removed.",
  planCancel: "Cancel",
  planReturnConfirming: "Confirming your payment… This can take a few seconds.",
  planReturnActive: "Subscription active.",
  planReturnSlow: "Stripe received the payment and it's being confirmed. You can close this page; we'll email you.",
  planReturnCancel: "Nothing was charged.",
  planErrCard: "Validate a card first.",
  planErrDisabled: "Subscriptions aren't open yet.",
  planErrNotActive: "The account isn't active yet.",
  planErrInProgress: "A subscription is already being set up. Wait a minute and reload this page.",
  planErrNoCustomer: "There's no payment account yet. Subscribe first.",
  planErrStripe: "We couldn't open the payment page right now. Try again in a few minutes.",
  planLoadError: "Couldn't load billing details. Try again.",
  planBannerPastDue: "Payment is pending. Update your card to start new broadcasts.",
  planBannerTrialEnding: "Free trial: {minutes} minutes left. Subscribe to keep broadcasting after it ends.",
  planBannerLimit80: "You've used 80% of this month's spending limit (US$ {used} of US$ {limit}).",
  planBannerLimit100: "This month's spending limit has been reached (US$ {used} of US$ {limit}).",
  planOpen: "Open plan",

  // Broadcast
  bcTitle: "Broadcast",
  bcLead: "Connect the microphone and broadcast to your audience.",
  bcInputTitle: "1. Audio input",
  bcDeviceLabel: "Audio input",
  bcDevicePlaceholder: "Allow audio access first",
  bcGrant: "Allow audio access",
  bcGranted: "Access granted",
  bcUnnamedInput: "Unnamed input",
  bcMicDenied: "The browser blocked access to the microphone or line input.",
  bcAudioError: "The audio input could not be sent.",
  bcAudioFormat: "Your audio device's format isn't supported. Choose another audio input.",
  bcChecklistTitle: "2. Checklist before going live",
  bcCheckDevice: "Audio input selected",
  bcCheckSignal: "Sound coming from the microphone (speak or play something)",
  bcLevelLabel: "Input level",
  bcQrTitle: "3. QR code for the audience",
  bcQrHelp: "Show or project this code. Anyone who scans it opens the translation on their own phone, with nothing to install.",
  bcQrAlt: "QR code with the link to listen",
  bcListenerUrlLabel: "Listener link",
  bcCopy: "Copy link",
  bcCopied: "Copied",
  bcEnlarge: "Enlarge",
  bcShrink: "Shrink",
  bcRegenerate: "Generate new link",
  bcRegenerateConfirm: "Printed QR codes will stop working.",
  bcRegenerateLive: "The broadcast is live. Stop it before generating a new link.",
  bcPresetTitle: "4. Broadcast preset",
  bcPresetHelp: "Choose the speaker's language and what the audience can hear. It can only change while the broadcast is stopped.",
  bcSpeakerLabel: "Speaker language",
  bcVoiceLabel: "Translation voice",
  bcAudienceLabel: "Languages the audience can choose",
  bcCostPerHour: "Cost: US$ {total}/hr",
  bcCostDetail: "US$ {price} per hour for each audience language.",
  bcTestVoice: "Test voice",
  bcSavePreset: "Save preset",
  bcPresetSaved: "Preset saved. It applies the next time you start.",
  bcStartSaveFailed: "Couldn't save the preset, so the broadcast didn't start. Check your connection and try again.",
  bcPresetInvalid: "Choose at least one audience language, different from the speaker's language.",
  bcPresetLocked: "The broadcast is live: stop it to change the preset. The pace changes right away.",
  bcPresetOwnerOnly: "Only the account owner can change languages and voice.",
  bcPreviewPickLanguage: "Select an audience language to hear the sample in it.",
  bcPreviewLoading: "Generating the sample…",
  bcPreviewPlaying: "Playing the {voice} voice in {language}.",
  bcPreviewPending: "Voice preview is available after approval.",
  bcPreviewLive: "The broadcast is live. Stop it to test a voice.",
  bcPreviewBusy: "A voice sample is already being generated. Try again in a moment.",
  bcPreviewFailed: "Could not play the voice sample right now. Please try again.",
  bcPaceTitle: "5. Translation pace",
  bcPaceLabel: "Pause that ends a sentence:",
  bcPaceValue: "{ms} ms",
  bcPaceFast: "200 ms · responds sooner",
  bcPaceFull: "400 ms · whole sentences",
  bcPaceHelp: "How much silence the speaker needs before the system treats the sentence as finished. You can change it during the broadcast and choose by ear.",
  bcLost: "{count} sentence(s) lost: the speaker kept talking while the previous one was still being translated. Increase the pause or ask for clearer pauses.",
  bcLiveTitle: "6. Broadcast",
  bcStart: "Start broadcasting",
  bcStop: "Stop",
  bcStateLabel: "Status:",
  bcStateStopped: "Stopped",
  bcStateConnecting: "Connecting…",
  bcStateLive: "Live",
  bcStateReconnecting: "Reconnecting…",
  bcAlreadyLive: "Your organization is already live in another window or device.",
  bcInvalidPreset: "The saved preset is not valid. Fix it and save it before starting.",
  bcDisconnected: "Lost the connection to the translation server. Trying again…",
  bcBillingPausedOwner: "New broadcasts are paused for this account.",
  bcBillingPausedOperator: "New broadcasts are paused. Ask your account owner.",
  bcBlockedCardRequired: "Validate a card to start the free trial.",
  bcBlockedPastDue: "Payment is pending. New broadcasts are paused until it's paid.",
  bcBlockedSpendLimit: "This month's spending limit has been reached.",
  bcOverageTitle: "This month's spending limit has been reached",
  bcOverageBody: "Go live anyway? This confirmation covers one broadcast.",
  bcOverageConfirm: "Go live anyway",
  bcOverageCancel: "Not now",
  bcTrialEnded: "The free trial has ended.",
  bcTrialEndedOperator: "The free trial has ended. Ask your account owner to subscribe.",
  bcSubscribe: "Subscribe",
  bcUpdatePayment: "Update payment",
  bcAddCard: "Add a card",
  bcReviewLimit: "Review spending limit",
  bcSubscriptionsSoon: "Subscriptions open soon. Contact Aulra support.",
  bcTrialNotice: "{n} min left in the free trial. Translation will stop when the trial ends.",
  bcTrialLeft: "Free trial: {minutes} language-hour minutes left.",
  bcTrialLeftHelp: "Each audience language uses trial time: a broadcast in 2 languages uses 2 minutes per minute.",
  // Assumir daqui (D11), limite de 1 h da sessão do motor e duração máxima.
  bcAlreadyLiveSince: "Live on another device since {time}. If you take over here, that device stops sending audio. Listeners stay connected.",
  bcTakeOver: "Take over here",
  bcTakenOver: "This broadcast was taken over on another device. Listeners are still connected.",
  bcSessionEnded: "The broadcast ended at the 1-hour session limit. Press Start to begin a new one.",
  bcSessionRenewFailed: "We couldn't start a new session, so the broadcast ended. Press Start to try again.",
  bcMaxDurationEnded: "The broadcast reached its maximum duration and ended. Press Start to begin a new one.",
  bcMaxDurationNotice: "Broadcast ends in {n} min (maximum duration).",
  bcLimitTitle: "This session has reached 1 hour",
  bcLimitBody: "Start another one to keep translating? Listeners stay connected. With no answer, the broadcast ends.",
  bcLimitRenewing: "Starting a new session…",
  bcLimitYes: "Yes, keep translating",
  bcLimitNo: "No, end ({seconds})",
  bcLimitCountdown: "{seconds} seconds left to answer.",

  // Início do painel (ORG-INICIO): só números que já existem; a fatura é da Fase 6.
  homePanelTitle: "Home",
  homeLiveTitle: "Your organization is live now.",
  homeOpenConsole: "Go to the console",
  homeMonthTitle: "This month",
  homeStatEvents: "Broadcasts",
  homeStatListeners: "People who listened",
  homeStatListenersSub: "sum of each broadcast's peak",
  homeStatHours: "Language-hours translated",
  homeLatestTitle: "Latest broadcasts",
  homeEmpty: "No broadcasts yet. Run a short test in the console before your event.",
  homeSeeHistory: "See history",
  homeLoadFailed: "Could not load this. Reload the page to try again.",
  homePrivacyTitle: "Aulra translates and forgets.",
  homePrivacyBody: "We don't keep audio or text from your events. Here you only see numbers.",

  // Tema (ThemeToggle do topo)
  themeLabel: "Theme",
  themeSystem: "System",
  themeLight: "Light",
  themeDark: "Dark",

  // Página não encontrada (404.html)
  notFoundTitle: "Page not found",
  notFoundBody: "The link may be wrong, or the page was moved.",
  notFoundHome: "Go to the home page",

  // History
  histTitle: "History",
  histLead: "Your past broadcasts, newest first.",
  histLive: "live",
  histEmpty: "No broadcasts yet. They appear here after your first one.",
  histColDate: "Date",
  histColDuration: "Duration",
  histColLanguages: "Languages",
  histColHours: "Language-hours",
  histColPeak: "Peak listeners",
  histLoadFailed: "Could not load your broadcast history. Please try again.",
  histShowingLatest: "Showing your latest {count} broadcasts.",

  // Organization
  orgTitle: "Organization",
  orgLead: "Your organization's details.",
  orgStreetLabel: "Street address",
  orgCityLabel: "City",
  orgStateLabel: "State",
  orgZipLabel: "ZIP code",
  orgCountryLabel: "Country",
  orgSave: "Save",
  orgSaved: "Saved.",
  orgSaveFailed: "Could not save your changes. Please try again.",
  emailChangeTitle: "Change your email",
  emailChangeHelp: "Enter the new address and a code from your authenticator app.",
  emailCurrentLabel: "Current email",
  emailNewLabel: "New email",
  emailChangeSubmit: "Change email",
  emailChangeInvalid: "Enter a valid email address.",
  emailChangeSame: "That is already your email.",
  emailChangeTaken: "That email can't be used. Try another address.",
  emailChangeSent:
    "We sent a confirmation link to both your current and your new email. The change takes effect after you confirm both.",

  // Security
  secTitle: "Security",
  secLead: "Your password, authenticator and recovery codes.",
  secPasswordTitle: "Change your password",
  secCurrentPasswordLabel: "Current password",
  secNewPasswordLabel: "New password",
  secPasswordSubmit: "Change password",
  secPasswordWrong: "Your current password is not correct.",
  secPasswordSame: "Choose a password different from your current one.",
  secPasswordChanged: "Your password was changed.",
  secPasswordWeak: "The new password does not meet the requirements.",
  secNonceLabel: "Confirmation code from email",
  secNonceSent: "For your security, we emailed you a confirmation code. Enter it below and submit again.",
  secNonceInvalid: "That confirmation code is not valid. Check the email and try again.",
  secAppTitle: "Change your authenticator",
  secAppHelp: "Enter a code from your current authenticator, then set up the new one. Your current authenticator keeps working until the new one is confirmed.",
  secAppStart: "Continue",
  secAppNewHelp: "Scan this QR code with the new authenticator, then enter the 6-digit code it shows.",
  secAppNewConfirm: "Confirm new authenticator",
  secAppChanged: "Your authenticator was changed. Use the new one the next time you sign in.",
  secAppChangedPartial: "The new authenticator is active, but the old one could not be removed. Please contact support.",
  secAppCancel: "Cancel",
  secCodesTitle: "Recovery codes",
  secCodesHelp: "Each recovery code works once if you lose your authenticator. Generating new codes replaces the ones you have.",
  secCodesGenerate: "Generate new recovery codes",
  secCodesConfirm: "Generate new codes? Your previous recovery codes will stop working.",
  secCodesWarning: "Your previous recovery codes no longer work. Save these ones somewhere safe. They will not be shown again.",

  // Painel do dono (admin.html)
  adminTitle: "Platform admin",
  adminOverview: "Overview",
  adminCost: "API cost (last 24h, estimated)",
  adminCostSub: "{amount} month to date",
  adminOperators: "Active operators (last 24h)",
  adminOperatorsSub: "of {total} organizations",
  adminBroadcasts: "Broadcasts (last 24h)",
  adminBroadcastsSub: "{live} live now",
  adminMinutes: "Translation minutes (last 24h)",
  adminMinutesSub: "≈ {cost} / min",
  adminPending: "Pending approval",
  adminOrgs: "Organizations",
  adminSearch: "Search by name or email",
  adminFilterAll: "All",
  adminColName: "Organization",
  adminColEmail: "Email",
  adminColSignup: "Signed up",
  adminColActive: "Last active",
  adminColMinutes: "Minutes (month)",
  adminColCost: "Cost (month, estimated)",
  adminColStatus: "Status",
  adminColActions: "Actions",
  adminNever: "never",
  adminEmpty: "No organizations found.",
  adminStatusLive: "Live",
  adminStatusActive: "Active",
  adminStatusPending: "Pending",
  adminStatusSuspended: "Suspended",
  adminApprove: "Approve",
  adminReject: "Reject",
  adminSuspend: "Suspend",
  adminReactivate: "Reactivate",
  adminReset2fa: "Reset 2FA",
  adminReasonTitle: "{action}: {name}",
  adminReasonLabel: "Reason (required)",
  adminConfirm: "Confirm",
  adminCancel: "Cancel",
  adminDone: "Done.",
  adminSuspendedNotStopped: "Account suspended. The live broadcast will stop within a minute.",
  adminApprovedNoEmail: "Account approved, but the approval email could not be sent.",
  adminErrConflict: "The account status changed. Reload the list and try again.",
  adminErrNotFound: "Organization not found.",
  adminErrForbidden: "You do not have permission to do this.",
  adminErrGeneric: "Something went wrong. Please try again.",

  // Equipe (ORG-EQUIPE, só o responsável) — Fase 4
  navTeam: "Team",
  teamTitle: "Team",
  teamLead: "Invite operators to run broadcasts. Each operator has their own sign-in, password and authenticator app. Operators can broadcast and see history, but can't change settings, billing or the team.",
  teamInviteTitle: "Invite an operator",
  teamInviteHelp: "We'll email them a link to join. The invitation is valid for 24 hours; use Resend after that. Someone who already has an Aulra account can't be invited yet.",
  teamInviteSubmit: "Send invitation",
  teamInviteSent: "Invitation sent to {email}.",
  teamMembersTitle: "Members",
  teamColEmail: "Email",
  teamColRole: "Role",
  teamColSince: "Since",
  teamColActions: "Actions",
  teamRoleOwner: "Account owner",
  teamRoleOperator: "Operator",
  teamNoOperators: "No operators yet.",
  teamRemove: "Remove",
  teamRemoveConfirm: "Remove {email}? They lose access right away. A broadcast they already started keeps running until it's stopped.",
  teamRemoved: "{email} was removed.",
  teamInvitationsTitle: "Pending invitations",
  teamColStatus: "Status",
  teamNoInvitations: "No pending invitations.",
  teamInvitePending: "Valid until {date}",
  teamInviteExpired: "Expired. Use Resend to send a new link.",
  teamResend: "Resend",
  teamRevoke: "Revoke",
  teamRevokeConfirm: "Revoke the invitation for {email}?",
  teamRevoked: "Invitation revoked.",
  teamLoadFailed: "Could not load the team. Reload the page to try again.",
  teamErrInvalidEmail: "Enter a valid email address.",
  teamErrHasAccount: "This email already has an Aulra account and can't be invited.",
  teamErrTooManyInvites: "Invitation limit reached: up to 10 pending invitations, 20 invitations a day and 3 a day to the same email. Revoke a pending invitation or try again tomorrow.",
  teamErrTooManyMembers: "Your team is full (20 people, counting pending invitations).",
  teamErrOrgNotActive: "Invitations are available once your account is active.",
  teamErrSendFailed: "We couldn't send the invitation email. Please try again.",
  teamErrRemoveOwner: "The account owner can't be removed.",
  teamErrNotFound: "That person or invitation is no longer on the team. Reload to update the list.",
  teamErrForbidden: "Only the account owner can manage the team.",

  // Aceite do convite (AUTH-CONVITE)
  inviteTitle: "Join your team on Aulra",
  inviteLead: "Choose a password for your account. Next, you'll set up an authenticator app.",
  inviteSubmit: "Set password and continue",
  inviteChecking: "Checking your invitation…",
  inviteInvalidTitle: "This invitation link doesn't work",
  inviteInvalidBody: "Invitation links are valid for 24 hours and work once. Ask your account owner to use Resend for a new link. If you already set your password, sign in. If you opened the link before but never set a password, ask your account owner to remove you from the team and invite you again, so you can set a new one.",
  inviteSignIn: "Go to sign in",
  invitePasswordFailed: "Could not save your password. Please try again.",
  inviteWeakPassword: "Choose a stronger password that meets all the rules.",
  noOrganizationInvite: "You no longer have access to this organization, or your invitation is no longer valid. Ask your account owner.",

  // Passo "Cartão" (card.html, Task 15): só o responsável, com a cobrança ligada
  cardTitle: "Validate a card",
  cardIntro: "We validate your card to start your free trial. Nothing is charged now.",
  cardHelp: "Card details go straight to Stripe, our payment provider. Aulra never sees your card number.",
  cardContinue: "Continue to Stripe",
  cardConfirming: "Confirming your card…",
  cardCanceled: "Card validation was canceled. You can try again whenever you're ready.",
  cardTimeout: "We're still confirming your card. This can take a minute. Reload this page to check again.",
  cardValidatedTrial: "Your card is confirmed. Your free trial is ready.",
  cardValidatedReused: "This card was already used for a free trial. You can subscribe to start.",
  cardGoToConsole: "Go to the console",
  cardErrDisabled: "Card validation isn't open yet. Contact Aulra support.",
  cardErrAlready: "Your card is already validated.",
  cardErrForbidden: "Only the account owner can add a card.",
  cardErrOrgNotActive: "Your account isn't active yet (awaiting approval or suspended). Contact Aulra support.",
  cardErrTooMany: "Too many attempts. Please try again in an hour.",
  cardErrGeneric: "Could not open the card page. Please try again.",

  // Nomes de idiomas e vozes (códigos de server/src/pipeline/languages.ts)
  lang_pt: "Portuguese",
  lang_en: "English",
  lang_es: "Spanish",
  lang_fr: "French",
  lang_de: "German",
  lang_it: "Italian",
  lang_ru: "Russian",
  lang_ja: "Japanese",
  lang_ko: "Korean",
  lang_zh: "Chinese",
  lang_hi: "Hindi",
  lang_id: "Indonesian",
  lang_vi: "Vietnamese",
  voice_marin: "Marin",
  voice_cedar: "Cedar",
} as const;

export type StringKey = keyof typeof en;

// Troca {nome} pelo valor. Variável faltando deixa o {nome} visível, para o erro aparecer.
export function t(key: StringKey, vars?: Record<string, string | number>): string {
  return en[key].replace(/\{(\w+)\}/g, (m, name: string) =>
    vars && name in vars ? String(vars[name]) : m,
  );
}
